import React, { useCallback, useEffect } from 'react'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import {
  selectCrossClientLandingPollableExecutions,
  selectCrossClientLandingPollingEnabled,
  setCrossClientLandingRunningExecutionProgresses,
  startCrossClientLandingPolling,
  stopCrossClientLandingPolling,
} from '../../../../store/crossClient/crossClientLanding'
import { useLazyGetCrossClientQueryExecutionProgressQuery } from '../../../../store/crossClient/crossClient'
import { usePollingEffect } from '../../../../apps/professional-app/fa/common/hooks/usePollingEffect'

export const CrossClientRunningExecutionsPoller: React.FC = () => {
  const dispatch = useAppDispatch()

  const accountId = useAppSelector(selectAccountId)
  const pollableExecutions = useAppSelector(selectCrossClientLandingPollableExecutions)
  const pollingEnabled = useAppSelector(selectCrossClientLandingPollingEnabled)

  const [triggerGetCrossClientQueryProgress] = useLazyGetCrossClientQueryExecutionProgressQuery()

  useEffect(() => {
    const shouldPoll = pollableExecutions.length > 0
    if (shouldPoll && !pollingEnabled) {
      dispatch(startCrossClientLandingPolling())
    } else if (!shouldPoll && pollingEnabled) {
      dispatch(stopCrossClientLandingPolling())
    }
  }, [dispatch, pollableExecutions, pollingEnabled])

  const getCrossClientRunningExecutionProgress = useCallback(async () => {
    try {
      const progresses = []
      for (const execution of pollableExecutions) {
        const progress = await triggerGetCrossClientQueryProgress({ accountId, executionId: execution.id }).unwrap()
        if (progress) {
          progresses.push(progress)
        }
      }
      if (progresses.length) {
        dispatch(setCrossClientLandingRunningExecutionProgresses(progresses))
      }
    } catch (e) {
      console.error(e)
      dispatch(stopCrossClientLandingPolling())
    }
  }, [dispatch, accountId, pollableExecutions, triggerGetCrossClientQueryProgress])

  const { start: startCrossClientRunningExecutionPolling, stop: stopCrossClientRunningExecutionPolling } = usePollingEffect(
    getCrossClientRunningExecutionProgress,
    [],
    {
      interval: 5000,
    },
  )

  useEffect(() => {
    if (pollingEnabled) {
      startCrossClientRunningExecutionPolling()
    } else {
      stopCrossClientRunningExecutionPolling()
    }
  }, [pollingEnabled, startCrossClientRunningExecutionPolling, stopCrossClientRunningExecutionPolling])

  return null
}
